jQuery(document).ready(function($) {
    var $lastFocused = null;

    function openPopup($popup) {
        $popup.fadeIn(300, function() {
            $popup.find(".close").first().focus();
        });
    }

    function closePopup($popup) {
        $popup.fadeOut(300, function() {
            if ($lastFocused) {
                $lastFocused.focus();
                $lastFocused = null;
            }
        });
    }

    $(document).on("click", "#book_popup", function() {
        $lastFocused = $(this);
        openPopup($("#popup-book-content"));
    });

    $("#popup-book-content .close").click(function() {
        closePopup($("#popup-book-content"));
    });

    $(document).keydown(function(event) {
        if (event.key === "Escape" && $("#popup-book-content").is(":visible")) {
            closePopup($("#popup-book-content"));
        }
    });

    $(document).click(function(event) {
        if (
            !$(event.target).closest(".modal-contact-content").length &&
            !$(event.target).is("#book_popup") &&
            !$(event.target).closest("#book_popup").length
        ) {
            closePopup($("#popup-book-content"));
        }
    });

    $(".copy-adress").click(function() {
        var url = window.location.href;
        navigator.clipboard.writeText(url).then(function() {
            var $btn = $(".copy-adress");
            var original = $btn.html();
            $btn.html('<span class="material-symbols-outlined">check</span>Kopierad!');
            setTimeout(function() {
                $btn.html(original);
            }, 2000);
        });
    });

    $(".share-email").click(function() {
        var url = window.location.href;
        var subject = encodeURIComponent(document.title);
        var body = encodeURIComponent(url);
        window.location.href = 'mailto:?subject=' + subject + '&body=' + body;
    });
});
